import { render, staticRenderFns } from "./customizeKeyboard.vue?vue&type=template&id=5abeca2b&scoped=true"
import script from "./customizeKeyboard.vue?vue&type=script&lang=ts"
export * from "./customizeKeyboard.vue?vue&type=script&lang=ts"
import style0 from "./customizeKeyboard.vue?vue&type=style&index=0&id=5abeca2b&prod&lang=less&scoped=true"
import style1 from "./customizeKeyboard.vue?vue&type=style&index=1&id=5abeca2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abeca2b",
  null
  
)

export default component.exports